import React from 'react';
import { faAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, contactSnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_CONTACTS_QUERY } from './queries';

const ContactPicker: React.FC<{ element: DocumentElementType }> = ({
  element,
}) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_CONTACTS_QUERY}
    collectionField="documentElementContacts"
    icon={faAddressCard}
    iconColour="#0c7c87"
    variant="avatar"
    defaults={{
      label: 'Contact',
      placeholder: 'Search for a contact...',
    }}
    rowSubtitle={(row) => (row.email as string | null | undefined) || null}
    rowBadges={(row) => {
      const out: string[] = [];
      if (row.mobile) out.push(String(row.mobile));
      if (row.businessName) out.push(String(row.businessName));
      return out;
    }}
    rowToSnapshot={contactSnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.contact].contextSpec}
  />
);

export default ContactPicker;
